// extracted by mini-css-extract-plugin
module.exports = {"slider":"styles_slider__Hi1JM","image":"styles_image__3AZlx","dots":"styles_dots__2RDD3"};